<template>
  <div class="api-docs" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-card class="api-docs__card elevation-0">
      <div class="api-docs__toolbar">
        <div class="api-docs__toolbar-left">
          <div class="api-docs__icon">
            <v-icon>mdi-api</v-icon>
          </div>
          <div>
            <div class="api-docs__title">
              Dokumentasi Pengiriman Pesan by Api Service
            </div>
            <div class="api-docs__sub">
              Endpoint HTTP v2 untuk mengirim pesan WhatsApp dari aplikasi eksternal
            </div>
          </div>
        </div>
      </div>

      <div class="api-docs__body">
        <div class="api-docs__tips">
          <v-icon small color="#1f7a57" class="mr-2">mdi-key-variant</v-icon>
          Ambil <strong>apiKey</strong> dari menu Data Master → Pengaturan (per nomor gateway).
          Semua request memakai method <code>POST</code> dan body JSON.
        </div>

        <div class="api-docs__base">
          <span class="api-docs__base-label">Base URL</span>
          <code>{{ baseUrl }}api/v2</code>
          <v-btn icon x-small class="ml-1" @click="copyText(baseUrl + 'api/v2')">
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </div>

        <v-expansion-panels accordion flat class="api-docs__panels">
          <v-expansion-panel
            v-for="ep in endpoints"
            :key="ep.path"
            class="api-docs__panel"
          >
            <v-expansion-panel-header class="api-docs__panel-head">
              <div class="api-docs__panel-title">
                <span class="api-docs__method">POST</span>
                <span class="api-docs__path">{{ ep.path }}</span>
                <span class="api-docs__name">{{ ep.name }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="api-docs__desc">{{ ep.description }}</p>

              <div class="api-docs__section-label">Request body</div>
              <pre class="api-docs__code">{{ ep.body }}</pre>

              <div class="api-docs__section-label">cURL</div>
              <pre class="api-docs__code">{{ curl(ep) }}</pre>
              <v-btn
                text
                small
                class="api-docs__copy"
                @click="copyText(curl(ep))"
              >
                <v-icon left small>mdi-content-copy</v-icon>
                Salin cURL
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="api-docs__note">
          <strong>Catatan:</strong> prefix <code>/api/v2/send-box/*</code> tersedia
          sebagai jalur alternatif (sendbox) dengan payload yang sama untuk
          <code>send-message</code> dan <code>send-bulk-message</code>.
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "UtilityApiDocs",
  data() {
    return {
      endpoints: [
        {
          name: "Kirim pesan teks",
          path: "/send-message",
          description:
            "Kirim satu pesan teks ke nomor penerima. Nomor memakai format internasional tanpa +, contoh 62812xxxx.",
          body: `{
  "apiKey": "YOUR_API_KEY",
  "recieveNumber": "6281234567890",
  "message": "Halo, ini pesan dari API"
}`,
        },
        {
          name: "Kirim pesan bulk",
          path: "/send-bulk-message",
          description:
            "Kirim beberapa pesan sekaligus. Setiap item di array datas berisi nomor dan isi pesan.",
          body: `{
  "apiKey": "YOUR_API_KEY",
  "datas": [
    { "recieveNumber": "628111111111", "message": "Pesan 1" },
    { "recieveNumber": "628222222222", "message": "Pesan 2" }
  ]
}`,
        },
        {
          name: "Daftar group WhatsApp",
          path: "/list-groups",
          description:
            "Ambil daftar group yang terlihat pada sesi WhatsApp nomor gateway.",
          body: `{
  "apiKey": "YOUR_API_KEY"
}`,
        },
        {
          name: "Kirim pesan ke group",
          path: "/send-group-message",
          description:
            "Kirim pesan teks ke group. Opsional: mentionAll atau mentions (array nomor / JID).",
          body: `{
  "apiKey": "YOUR_API_KEY",
  "groupId": "1203630xxxxxxxxx@g.us",
  "message": "Halo group",
  "mentionAll": false,
  "mentions": ["6281234567890"]
}`,
        },
      ],
    };
  },
  computed: {
    ...mapState(["theme", "device", "snackbar", "page"]),
    baseUrl() {
      return this.page?.domainUrl || "";
    },
  },
  created() {
    this.setPage({
      crud: false,
      dataUrl: "api/",
      title: "DOKUMENTASI API",
      subtitle: "Pengiriman pesan via Api Service",
      breadcrumbs: [
        { text: "Utility", disabled: true, href: "" },
        {
          text: "Dokumentasi Pengiriman Pesan by Api Service",
          disabled: false,
          href: "",
        },
      ],
      actions: {
        refresh: false,
        add: false,
        edit: false,
        delete: false,
      },
      showtable: false,
    });
  },
  methods: {
    ...mapActions(["setPage"]),
    curl(ep) {
      return `curl -X POST "${this.baseUrl}api/v2${ep.path}" \\
  -H "Content-Type: application/json" \\
  -d '${ep.body.replace(/\n/g, " ").replace(/\s+/g, " ").trim()}'`;
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.snackbar.color = this.theme.color || "green";
        this.snackbar.text = "Disalin ke clipboard";
        this.snackbar.state = true;
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal menyalin";
        this.snackbar.state = true;
      }
    },
  },
};
</script>

<style scoped>
.api-docs {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}

.api-docs__card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.api-docs__toolbar {
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.api-docs__toolbar-left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.api-docs__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  flex-shrink: 0;
}

.api-docs__icon .v-icon {
  color: #0b3d2e !important;
}

.api-docs__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.3;
}

.api-docs__sub {
  margin-top: 0.2rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.api-docs__body {
  padding: 1.25rem;
}

.api-docs__tips {
  display: flex;
  align-items: flex-start;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: var(--gw-fog);
  border: 1px solid var(--gw-line);
  color: var(--gw-muted);
  font-size: 0.85rem;
  line-height: 1.45;
  margin-bottom: 1rem;
}

.api-docs__base {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  font-size: 0.85rem;
  color: var(--gw-ink);
}

.api-docs__base-label {
  font-weight: 700;
  color: var(--gw-forest);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.api-docs__base code {
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  background: #f4f7f5;
  border: 1px solid var(--gw-line);
  font-size: 0.82rem;
}

.api-docs__panels {
  border: 1px solid var(--gw-line);
  border-radius: 10px;
  overflow: hidden;
}

.api-docs__panel {
  border-bottom: 1px solid var(--gw-line) !important;
}

.api-docs__panel:last-child {
  border-bottom: none !important;
}

.api-docs__panel-head {
  min-height: 52px !important;
  padding: 0.75rem 1rem !important;
}

.api-docs__panel-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  width: 100%;
  padding-right: 0.5rem;
}

.api-docs__method {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  padding: 0.2rem 0.45rem;
  border-radius: 4px;
  background: #1f7a57;
  color: #fff;
}

.api-docs__path {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--gw-forest);
}

.api-docs__name {
  font-size: 0.8rem;
  color: var(--gw-muted);
}

.api-docs__desc {
  font-size: 0.88rem;
  color: var(--gw-muted);
  margin: 0 0 1rem;
  line-height: 1.5;
}

.api-docs__section-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--gw-forest);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.4rem;
}

.api-docs__code {
  margin: 0 0 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  background: #0b3d2e;
  color: #d8f5e8;
  font-size: 0.78rem;
  line-height: 1.55;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.api-docs__copy {
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: var(--gw-leaf) !important;
  font-weight: 700 !important;
  margin-bottom: 0.5rem;
}

.api-docs__note {
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px dashed var(--gw-line);
  font-size: 0.82rem;
  color: var(--gw-muted);
  line-height: 1.5;
}

.api-docs__note code {
  font-size: 0.78rem;
  color: var(--gw-forest);
}
</style>
